// Pendiente de revisar
import i18n from "@/i18n/i18n";
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class ProfileDto extends ItiBaseDto {
	public userId: string;
	public fullName: string;
	public email: string;
	public userStatus: string;
	public tenantId: string;
	public tenantName: string;
	public tenantNomenclature: string;
	public groupId: string;
	public groupName: string;
	public groupNomenclature: string;
	public personalId: string;
	public personalName: string;
	public personalNomenclature: string;
	public resourceType: string;
	public roleName: string;
	public status: string;
	public resourceTypeId: number;
	public roleId: number;

	public get translatedStatus() {
		return i18n.t(`status.${this.status.toLocaleLowerCase()}`);
	}

	public get translatedRole() {
		return i18n.t(`roleName.${this.roleName.toLocaleLowerCase()}`);
	}

	public get profile() {
		return `${this.tenantName}/${this.groupName}/${this.personalName}`;
	}

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
